import { createTheme, responsiveFontSizes } from '@mui/material/styles';
import { palette } from './palette';
import { typography } from './typography';
import { components } from './components';

let theme = createTheme({
    palette,
    typography,
    components,
    shape: {
        borderRadius: 8,
    },
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 900,
            lg: 1200,
            xl: 1536,
        },
    },
});

// Make fonts responsive
theme = responsiveFontSizes(theme);

export { theme };
